import {
  IconCalculator24Line as CalculatorIcon,
  IconDocumentLines24Line as DocumentIcon,
} from "@wayflyer/flyui-icons/24/line";

import { ConnectorLogo } from "../connector-button";
import { ConnectorIconBorder, ConnectorIconContainer } from "../../styled/index";

const WrappedIcon = ({ children }) => {
  return (
    <ConnectorIconContainer>
      <ConnectorIconBorder>{children}</ConnectorIconBorder>
    </ConnectorIconContainer>
  );
};

export interface PlatformImageProps {
  connectorType: string;
  logoOverride?: React.ReactNode;
}

export const PlatformImage = ({ connectorType, logoOverride }: PlatformImageProps) => {
  if (connectorType === "Codat File Uploads") {
    return (
      <WrappedIcon>
        <DocumentIcon />
      </WrappedIcon>
    );
  }
  if (connectorType === "Codat Accounting") {
    return (
      <WrappedIcon>
        <CalculatorIcon />
      </WrappedIcon>
    );
  }
  if (logoOverride) {
    return <>{logoOverride}</>;
  }
  return <ConnectorLogo connectorName={connectorType} size="small" />;
};
